export const OPTION_TYPES = {
  CHECKBOX: 'checkbox',
  RADIO: 'radio',
};
